(function () {
	let abortController = null;

	const swingEase = (progress) => 0.5 - Math.cos(progress * Math.PI) / 2;

	const slideAnimations = new WeakMap();

	const stopSlide = (element) => {
		const animation = slideAnimations.get(element);
		if (!animation) return;

		cancelAnimationFrame(animation.rafId);
		slideAnimations.delete(element);
	};

	const slideDown = (element, duration = 300) => {
		stopSlide(element);

		const isHidden = window.getComputedStyle(element).display === "none";

		if (isHidden) {
			element.style.display = "block";
		}

		const targetHeight = element.scrollHeight;
		const startHeight = isHidden ? 0 : element.offsetHeight;

		element.style.overflow = "hidden";
		element.style.boxSizing = "border-box";
		element.style.height = `${startHeight}px`;

		const startTime = performance.now();

		const animate = (now) => {
			const elapsed = now - startTime;
			const linearProgress = Math.min(elapsed / duration, 1);
			const progress = swingEase(linearProgress);
			const currentHeight = startHeight + (targetHeight - startHeight) * progress;

			element.style.height = `${currentHeight}px`;

			if (elapsed < duration) {
				const rafId = requestAnimationFrame(animate);
				slideAnimations.set(element, { rafId });
				return;
			}

			element.style.height = "";
			element.style.overflow = "";
			slideAnimations.delete(element);
		};

		requestAnimationFrame(animate);
	};

	const slideUp = (element, duration = 300) => {
		stopSlide(element);

		const startHeight = element.offsetHeight;
		if (startHeight === 0) {
			element.style.display = "none";
			return;
		}

		element.style.overflow = "hidden";
		element.style.boxSizing = "border-box";
		element.style.height = `${startHeight}px`;

		const startTime = performance.now();

		const animate = (now) => {
			const elapsed = now - startTime;
			const linearProgress = Math.min(elapsed / duration, 1);
			const progress = swingEase(linearProgress);
			const currentHeight = startHeight * (1 - progress);

			element.style.height = `${currentHeight}px`;

			if (elapsed < duration) {
				const rafId = requestAnimationFrame(animate);
				slideAnimations.set(element, { rafId });
				return;
			}

			element.style.display = "none";
			element.style.height = "";
			element.style.overflow = "";
			slideAnimations.delete(element);
		};

		requestAnimationFrame(animate);
	};

	const initCollapsibleContent = () => {
		if (abortController) {
			abortController.abort();
		}

		abortController = new AbortController();
		const { signal } = abortController;

		document.querySelectorAll(".collapsible-content__toggle").forEach((toggle) => {
			toggle.addEventListener(
				"click",
				function () {
					const parent = this.parentElement;

					if (!parent.classList.contains("active")) {
						Array.from(parent.parentElement.children).forEach((sibling) => {
							if (
								sibling !== parent &&
								sibling.classList.contains("collapsible-content__item") &&
								sibling.classList.contains("active")
							) {
								sibling.classList.remove("active");
							}
						});
						parent.classList.add("active");
						this.closest(".collapsible-content__items")
							.querySelectorAll(".collapsible-content__answer")
							.forEach((answer) => {
								slideUp(answer, 300);
							});
						slideDown(this.nextElementSibling, 300);
					} else {
						parent.classList.remove("active");
						slideUp(this.nextElementSibling, 300);
					}
				},
				{ signal }
			);
		});

		document.querySelectorAll(".collapsible-content__item").forEach((item) => {
			item.addEventListener(
				"mouseenter",
				function () {
					this.classList.remove("collapsible-content__item--opacity");
					Array.from(this.parentElement.children).forEach((sibling) => {
						if (sibling !== this) {
							sibling.classList.add("collapsible-content__item--opacity");
						}
					});
				},
				{ signal }
			);

			item.addEventListener(
				"mouseleave",
				function () {
					Array.from(this.parentElement.children).forEach((sibling) => {
						if (sibling !== this) {
							sibling.classList.remove("collapsible-content__item--opacity");
						}
					});
				},
				{ signal }
			);
		});
	};

	document.addEventListener("shopify:section:load", initCollapsibleContent);

	initCollapsibleContent();
})();
